export default {"src":"/newStatic/_next/static/media/bitdroplet.f56514e4.svg","height":24,"width":24};